import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Heart, Sparkles, Clock, Shield, ShieldCheck, Gift, Zap, ArrowRight } from 'lucide-react';
import { SalesNotification } from '../components/SalesNotification';
import { initMetaPixel, trackPageView, trackAddToCart } from '../utils/metaPixel';
export function SalesPage() {
  // Initialize Meta Pixel and fire PageView on load
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  };
  const staggerContainer = {
    initial: {},
    whileInView: {
      transition: {
        staggerChildren: 0.1
      }
    },
    viewport: {
      once: true,
      margin: '-50px'
    }
  };
  const handleCheckout = () => {
    // Fire AddToCart event before redirecting
    trackAddToCart();
    try {
      window.location.href = 'https://www.conesenciavital.com/cart/47255503601903:1';
    } catch (error) {
      window.open('https://www.conesenciavital.com/cart/47255503601903:1', '_blank');
    }
  };
  return <div className="w-full bg-[#FDFBF7] min-h-screen font-sans text-gray-900" data-id="element-12">
      {/* Sales Notification - Mobile Only */}
      <SalesNotification data-id="element-13" />

      {/* SECTION 1: HERO (Above the fold) */}
      <section className="relative w-full overflow-hidden" data-id="element-14">
        <div className="grid md:grid-cols-2 min-h-[90vh] md:min-h-screen" data-id="element-15">
          {/* Image Side (Top on mobile, Left on desktop) */}
          <div className="relative h-[50vh] md:h-auto w-full" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/9aA48x7WVLRohA4PkAqsq1/hf_20260219_210738_b3299c8c-9c56-42d9-aea1-3eadb421e5d5.png" alt="Mujer latina mirándose al espejo con preocupación" className="w-full h-full object-cover object-top md:object-center" data-id="element-17" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#FDFBF7] via-transparent to-transparent md:hidden" data-id="element-18"></div>
          </div>

          {/* Content Side (Bottom on mobile, Right on desktop) */}
          <div className="flex flex-col justify-center px-6 py-8 md:p-16 lg:p-20 bg-[#FDFBF7]" data-id="element-19">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} data-id="element-20">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[var(--color-navy)] leading-tight mb-4 font-sans" data-id="element-21">
                Comes sano…haces ejercicio…evitas el azúcar…
              </h1>

              <p className="text-xl md:text-2xl text-gray-600 mb-6 leading-relaxed" data-id="element-22">
                y aun así cada mañana tu abdomen se siente más duro?
              </p>

              <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-23">
                Te miras al espejo. Te tocas el vientre. Y no entiendes qué está
                pasando.
              </p>

              <div className="space-y-2 mb-6" data-id="element-24">
                <p className="text-xl md:text-2xl font-normal text-gray-600" data-id="element-25">
                  No es tu edad. No es tu metabolismo. No es falta de
                  disciplina.
                </p>
                <p className="text-3xl md:text-4xl font-bold text-[var(--color-coral)] uppercase tracking-wide" data-id="element-26">
                  ES INFLAMACIÓN.
                </p>
                <p className="text-2xl md:text-3xl font-medium text-gray-400 italic" data-id="element-27">
                  Silenciosa. Acumulándose día tras día.
                </p>
              </div>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-28">
                Y si no la desactivas, seguirá volviendo.
                <br data-id="element-29" />
                <br data-id="element-30" />
                Desactívala en solo 7 días con un método práctico diseñado para
                mujeres que hacen todo bien… pero siguen atrapadas en un abdomen
                pesado que no responde.
              </p>

              <ul className="space-y-3 mb-8" data-id="element-31">
                {['Te despiertas más inflamada que cuando te acostaste', 'Tu ropa aprieta aunque "hiciste todo bien"', 'Comes sano… y nada cambia', 'Sientes el vientre duro y pesado casi todos los días'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-32">
                    <CheckCircle2 className="w-5 h-5 text-[var(--color-coral)] flex-shrink-0" data-id="element-33" />
                    <span className="text-gray-800 font-medium" data-id="element-34">{item}</span>
                  </li>)}
              </ul>

              <div className="space-y-4" data-id="element-35">
                <button onClick={handleCheckout} className="w-full md:w-auto bg-[var(--color-coral)] hover:bg-[var(--color-coral-dark)] text-white font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-36">
                  QUIERO DESINFLAMARME DESDE HOY
                  <ArrowRight className="w-5 h-5" data-id="element-37" />
                </button>

                <div className="text-center md:text-left" data-id="element-38">
                  <p className="text-sm font-normal text-gray-600" data-id="element-39">
                    Pago único – Descarga inmediata
                  </p>
                  <div className="flex items-center justify-center md:justify-start gap-2 mt-2 text-sm text-gray-500" data-id="element-40">
                    <ShieldCheck className="w-4 h-4" data-id="element-41" />
                    <span data-id="element-42">
                      Pago 100% seguro • Acceso inmediato en tu correo
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 2: IDENTIFICATION BLOCK */}
      <section className="py-20 px-6 bg-[var(--color-warm-beige)]" data-id="element-43">
        <div className="max-w-3xl mx-auto text-center" data-id="element-44">
          <motion.div {...fadeInUp} data-id="element-45">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-navy)] mb-8 font-serif" data-id="element-46">
              No es tu culpa.
            </h2>
            <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-47">
              <p data-id="element-48">Te esfuerzas. Comes mejor. Intentas cuidarte.</p>
              <p className="font-semibold text-[var(--color-coral)] text-2xl" data-id="element-49">
                Y aun así… tu vientre sigue inflamado.
              </p>
              <p data-id="element-50">
                Te preguntas qué estás haciendo mal. Te frustras. Te sientes
                estancada.
              </p>
              <p className="font-semibold text-[var(--color-navy)] text-xl" data-id="element-51">
                La realidad es más profunda:
              </p>
              <p data-id="element-52">
                No es grasa acumulada. Es inflamación interna que nadie te
                enseñó a desactivar.
              </p>
              <p className="font-medium text-gray-700 italic" data-id="element-53">
                Y mientras no la trabajes desde la raíz… seguirá volviendo.
              </p>
            </div>

            <button onClick={handleCheckout} className="mt-10 bg-white border-2 border-[var(--color-coral)] text-[var(--color-coral)] hover:bg-[var(--color-coral)] hover:text-white font-bold text-lg px-10 py-4 rounded-full transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-54">
              QUIERO DESACTIVAR LA INFLAMACIÓN
            </button>
          </motion.div>
        </div>
      </section>

      {/* SECTION 2.5: EMOTIONAL DEPTH */}
      <section className="py-20 px-6 bg-[#FDFBF7]" data-id="element-55">
        <div className="max-w-3xl mx-auto text-center" data-id="element-56">
          <motion.div {...fadeInUp} data-id="element-57">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-navy)] mb-8 font-sans" data-id="element-58">
              La inflamación no solo cambia tu abdomen.
            </h2>
            <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-59">
              <p data-id="element-60">
                La inflamación no solo se nota en el espejo. Se siente por
                dentro.
              </p>
              <p data-id="element-61">
                Te hace dudar de tu disciplina. Te hace cuestionar tu cuerpo. Te
                hace pensar que algo está mal contigo.
              </p>
              <p data-id="element-62">
                Y poco a poco… va robando algo más importante que la ligereza.
              </p>
              <p className="text-2xl md:text-3xl font-bold text-[var(--color-coral)]" data-id="element-63">
                Tu confianza.
              </p>
              <p data-id="element-64">Pero el problema no eres tú. Es inflamación.</p>
              <p className="font-semibold text-[var(--color-navy)] text-xl" data-id="element-65">
                Y sí se puede desactivar.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECTION 3: PRODUCT PRESENTATION */}
      <section className="py-20 px-6 bg-white" data-id="element-66">
        <div className="max-w-5xl mx-auto" data-id="element-67">
          <motion.div className="text-center mb-12" {...fadeInUp} data-id="element-68">
            <h2 className="text-3xl md:text-5xl font-bold text-[var(--color-navy)] mb-4 font-serif" data-id="element-69">
              Esto es lo que vas a recibir
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-70">
              Un método claro y estructurado para mujeres que están cansadas de
              hacer todo bien… y no ver cambios.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-71">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/iB8b2jmfAFfjBHYFWBsTfA/hf_20260220_195730_c3d96755-e2b4-4578-b9bb-f3164fda3523.jpg" alt="Mockup del libro No es Gordura, es Inflamación" className="w-full rounded-xl shadow-2xl" data-id="element-73" />
            </motion.div>

            <motion.div {...fadeInUp} data-id="element-74">
              <ul className="space-y-4 mb-8" data-id="element-75">
                {['Plan estructurado de 7 días para reducir visiblemente la inflamación desde la raíz.', 'Menú antiinflamatorio diseñado para deshinchar tu abdomen sin dietas extremas.', 'Rutinas simples para despertar menos inflamada y dormir sin pesadez.', 'Protocolo rápido para esos días en que te sientes más hinchada de lo normal.', 'Acceso inmediato en tu correo para empezar hoy mismo.'].map((item, index) => <li key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg" data-id="element-76">
                    <CheckCircle2 className="w-6 h-6 text-[var(--color-coral)] flex-shrink-0 mt-0.5" data-id="element-77" />
                    <span className="text-gray-800 font-medium text-lg" data-id="element-78">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <p className="text-center text-gray-500 mb-8 flex items-center justify-center gap-2" data-id="element-79">
                <Zap className="w-4 h-4" data-id="element-80" />
                Compatible con celular, tablet y computadora.
              </p>

              <button onClick={handleCheckout} className="w-full bg-[var(--color-coral)] hover:bg-[var(--color-coral-dark)] text-white font-bold text-xl px-8 py-5 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-81">
                QUIERO ACCESO INMEDIATO
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 3.5: BONUSES */}
      <section className="py-20 px-6 bg-[var(--color-warm-beige)]" data-id="element-82">
        <div className="max-w-4xl mx-auto" data-id="element-83">
          <motion.div className="text-center mb-16" {...fadeInUp} data-id="element-84">
            <div className="inline-flex items-center gap-2 bg-[var(--color-coral)] text-white px-6 py-2 rounded-full text-sm font-bold uppercase tracking-widest mb-6" data-id="element-85">
              <Gift className="w-4 h-4" data-id="element-86" />
              Bonos Exclusivos
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[var(--color-navy)] font-sans" data-id="element-87">
              Además, recibes estos bonos exclusivos:
            </h2>
          </motion.div>

          {/* Bonus 1 */}
          <motion.div className="bg-white rounded-3xl overflow-hidden shadow-xl mb-6" {...fadeInUp} data-id="element-88">
            <div className="grid md:grid-cols-2 items-center" data-id="element-89">
              <div className="h-64 md:h-full" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/8xTUpvMh2wB9PLu4s9LWhE/Mockup_en_formato_1x.png" alt="Menú Express Anti-Inflamación" className="w-full h-full object-cover" data-id="element-91" />
              </div>
              <div className="p-8 md:p-10" data-id="element-92">
                <div className="inline-block bg-[var(--color-coral)] text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-93">
                  Bono 1
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-[var(--color-navy)] font-sans mb-3 leading-tight" data-id="element-94">
                  Menú Express Anti-Inflamación 24 Horas
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-95">
                  Un plan estratégico para esos días en los que amaneces más
                  inflamada de lo normal.
                </p>
                <ul className="space-y-3 mb-6" data-id="element-96">
                  {['Plan completo de 24 horas', 'Versión sin lácteos y sin gluten', 'Checklist práctico', 'Ideal para eventos importantes'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-97">
                      <CheckCircle2 className="w-5 h-5 text-[var(--color-coral)] flex-shrink-0 mt-0.5" data-id="element-98" />
                      <span className="text-gray-700" data-id="element-99">{item}</span>
                    </li>)}
                </ul>
                <div className="inline-block bg-[var(--color-cream)] text-[var(--color-navy)] text-sm font-semibold px-4 py-2 rounded-full border border-gray-200" data-id="element-100">
                  Valor individual: $19 USD
                </div>
              </div>
            </div>
          </motion.div>

          {/* Divider */}
          <div className="flex items-center gap-4 my-8" data-id="element-101">
            <div className="flex-1 h-px bg-gray-300" data-id="element-102"></div>
            <div className="flex items-center gap-2 text-[var(--color-coral)]" data-id="element-103">
              <Gift className="w-5 h-5" data-id="element-104" />
              <span className="text-sm font-bold uppercase tracking-widest text-gray-500" data-id="element-105">
                + Bono 2
              </span>
              <Gift className="w-5 h-5" data-id="element-106" />
            </div>
            <div className="flex-1 h-px bg-gray-300" data-id="element-107"></div>
          </div>

          {/* Bonus 2 */}
          <motion.div className="bg-white rounded-3xl overflow-hidden shadow-xl mb-16" {...fadeInUp} data-id="element-108">
            <div className="grid md:grid-cols-2 items-center" data-id="element-109">
              <div className="h-64 md:h-full md:order-2" data-id="element-110">
                <img src="https://cdn.magicpatterns.com/uploads/18TT8fgiwGPEYXFLBJ3pk6/Mockup_cuadrado_(1x1.png" alt="30 Snacks Anti-Inflamación" className="w-full h-full object-cover" data-id="element-111" />
              </div>
              <div className="p-8 md:p-10 md:order-1" data-id="element-112">
                <div className="inline-block bg-[var(--color-coral)] text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-113">
                  Bono 2
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-[var(--color-navy)] font-sans mb-3 leading-tight" data-id="element-114">
                  30 Snacks Anti-Inflamación
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-115">
                  Opciones prácticas diseñadas para mantenerte ligera incluso en
                  tus días más ocupados.
                </p>
                <ul className="space-y-3 mb-6" data-id="element-116">
                  {['Snacks dulces y salados', 'Estabilizan la glucosa', 'Reducen ansiedad y antojos', 'Fáciles de llevar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-117">
                      <CheckCircle2 className="w-5 h-5 text-[var(--color-coral)] flex-shrink-0 mt-0.5" data-id="element-118" />
                      <span className="text-gray-700" data-id="element-119">{item}</span>
                    </li>)}
                </ul>
                <div className="inline-block bg-[var(--color-cream)] text-[var(--color-navy)] text-sm font-semibold px-4 py-2 rounded-full border border-gray-200" data-id="element-120">
                  Valor individual: $29 USD
                </div>
              </div>
            </div>
          </motion.div>

          {/* Value Stacking */}
          <motion.div className="bg-[var(--color-navy)] rounded-3xl p-10 text-center text-white" {...fadeInUp} data-id="element-121">
            <p className="text-lg text-gray-400 mb-1 line-through" data-id="element-122">
              Valor total del paquete: $49 USD
            </p>
            <p className="text-xl text-gray-300 mb-2" data-id="element-123">Hoy accedes por solo</p>
            <p className="text-6xl md:text-7xl font-bold text-[var(--color-coral)] mb-8 tracking-tight" data-id="element-124">
              $9.97 <span className="text-2xl text-white opacity-60" data-id="element-125">USD</span>
            </p>
            <button onClick={handleCheckout} className="bg-[var(--color-coral)] hover:bg-[var(--color-coral-dark)] text-white font-bold text-xl px-12 py-5 rounded-full shadow-xl transition-all transform hover:scale-105 flex items-center gap-3 mx-auto mb-4" data-id="element-126">
              QUIERO TODO EL PAQUETE COMPLETO
              <ArrowRight className="w-5 h-5" data-id="element-127" />
            </button>
            <p className="text-sm text-gray-400" data-id="element-128">
              Pago único • Acceso inmediato • Descarga digital
            </p>
          </motion.div>
        </div>
      </section>

      {/* SECTION 4: BENEFITS */}
      <section className="py-20 px-6 bg-[var(--color-cream)]" data-id="element-129">
        <div className="max-w-4xl mx-auto" data-id="element-130">
          <motion.h2 className="text-3xl md:text-5xl font-bold text-[var(--color-navy)] text-center mb-12 font-serif" {...fadeInUp} data-id="element-131">
            Lo que empezarás a sentir
          </motion.h2>

          <motion.div className="grid md:grid-cols-2 gap-6" variants={staggerContainer} initial="initial" whileInView="whileInView" viewport={{
          once: true
        }} data-id="element-132">
            {['Abdomen más ligero desde los primeros días', 'Digestión más cómoda', 'Menos gases y retención', 'Más energía y claridad mental', 'Menos ansiedad por la comida', 'Sensación de control sobre tu cuerpo'].map((benefit, index) => <motion.div key={index} className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" variants={fadeInUp} data-id="element-133">
                <Sparkles className="w-6 h-6 text-[var(--color-coral)] flex-shrink-0" data-id="element-134" />
                <p className="text-[var(--color-navy)] font-semibold text-lg" data-id="element-135">
                  {benefit}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* SECTION 5: SOCIAL PROOF */}
      <section className="py-20 px-6 bg-white" data-id="element-136">
        <div className="max-w-6xl mx-auto" data-id="element-137">
          <motion.h2 className="text-3xl md:text-5xl font-bold text-[var(--color-navy)] text-center mb-16 font-serif" {...fadeInUp} data-id="element-138">
            Mujeres reales ya comenzaron
          </motion.h2>

          <motion.div className="grid md:grid-cols-3 gap-8" variants={staggerContainer} initial="initial" whileInView="whileInView" viewport={{
          once: true
        }} data-id="element-139">
            {[{
            quote: 'Volví a reconocer mi cuerpo.',
            name: 'María, 34'
          }, {
            quote: 'Me sentí más ligera en menos de una semana.',
            name: 'Carmen, 41'
          }, {
            quote: 'Mi energía cambió por completo.',
            name: 'Laura, 38'
          }].map((testimonial, index) => <motion.div key={index} className="bg-[var(--color-warm-beige)] p-8 rounded-2xl relative" variants={fadeInUp} data-id="element-140">
                <div className="absolute -top-4 left-8 bg-[var(--color-coral)] text-white p-2 rounded-full" data-id="element-141">
                  <Heart className="w-6 h-6" data-id="element-142" />
                </div>
                <p className="text-xl text-[var(--color-navy)] mb-6 italic font-serif leading-relaxed" data-id="element-143">
                  "{testimonial.quote}"
                </p>
                <p className="text-[var(--color-navy-light)] font-bold uppercase tracking-wide text-sm" data-id="element-144">
                  — {testimonial.name}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* SECTION 8: FINAL PRICE CLOSE */}
      <section className="py-24 px-6 bg-[var(--color-navy)] text-white text-center" data-id="element-145">
        <motion.div className="max-w-3xl mx-auto" {...fadeInUp} data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-147">
            Empieza hoy por solo
          </h2>
          <div className="text-7xl md:text-8xl font-bold text-[var(--color-coral)] mb-6 tracking-tight" data-id="element-148">
            $9.97 <span className="text-2xl text-white opacity-70" data-id="element-149">USD</span>
          </div>
          <p className="text-xl md:text-2xl text-gray-300 mb-4" data-id="element-150">
            Menos de lo que gastas en un café y un snack.
          </p>
          <p className="text-lg text-gray-400 mb-10" data-id="element-151">
            Pago único • Acceso inmediato • Empiezas hoy
          </p>

          <button onClick={handleCheckout} className="w-full md:w-auto bg-[var(--color-coral)] hover:bg-[var(--color-coral-dark)] text-white font-bold text-2xl px-12 py-6 rounded-full shadow-2xl hover:shadow-white/10 transition-all transform hover:scale-105 mb-6" data-id="element-152">
            SÍ, QUIERO DESINFLAMARME
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400 opacity-80" data-id="element-153">
            <ShieldCheck className="w-4 h-4" data-id="element-154" />
            <span data-id="element-155">Compra segura • Acceso inmediato por email</span>
          </div>
        </motion.div>
      </section>

      {/* GARANTÍA - Bottom after final CTA */}
      <section className="py-16 px-6 bg-[var(--color-warm-beige)]" data-id="element-156">
        <div className="max-w-3xl mx-auto text-center" data-id="element-157">
          <motion.div {...fadeInUp} data-id="element-158">
            <div className="w-16 h-16 bg-[var(--color-coral)] bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-159">
              <ShieldCheck className="w-8 h-8 text-[var(--color-coral)]" data-id="element-160" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-navy)] mb-6 font-sans" data-id="element-161">
              Prueba el método sin riesgo durante 7 días.
            </h2>
            <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-162">
              <p data-id="element-163">
                Si después de aplicar el plan no notas menos inflamación, mayor
                ligereza o mejor digestión, escríbenos y te devolvemos el 100%
                de tu dinero.
              </p>
              <p className="font-semibold text-[var(--color-navy)]" data-id="element-164">
                Sin preguntas. Sin complicaciones.
              </p>
              <p className="font-medium italic text-gray-600" data-id="element-165">
                La decisión es tuya. El riesgo es nuestro.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2530] text-gray-400 text-center py-10 px-6 border-t border-gray-800" data-id="element-166">
        <p className="opacity-75 text-sm" data-id="element-167">
          © 2024 No es Gordura, es Inflamación. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}